<template>
  <div id="app" ref="box">
      <router-view> </router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted(){//使用钩子函数来监听一下浏览器是否刷新
    window.addEventListener("unload",this.saveState);
    var el_ = this.$refs.box;
			this.$store.state.el_= el_;			
  },
  methods:{
    saveState(){//sessionStorage只能存字符串,将这块转为json格式的字符串
      sessionStorage.setItem('state',JSON.stringify(this.$store.state.user))
    },
  },
}
</script>


<style lang="less"  scoped>
#app {
  height:100vh;
}
</style>
